var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isEnabled
    ? _c("div", [
        _vm.showForm
          ? _c("div", { staticClass: "opportunity-form" }, [
              !_vm.addingNewProject
                ? _c("div", [
                    _c("div", { staticClass: "form-group col-lg-4 p-0" }, [
                      _c(
                        "label",
                        {
                          staticClass: "form-label",
                          attrs: { for: "existingProject" }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$resourceString[
                                  "checkout.SFDC.select-opportunity"
                                ]
                              ) +
                              "\n        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectedUserProject,
                              expression: "selectedUserProject"
                            }
                          ],
                          staticClass: "form-select custom-select",
                          attrs: { id: "existingProject" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.selectedUserProject = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { disabled: "", value: "" } }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "checkout.SFDC.existing-projects"
                                  ]
                                ) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.existingProjectOptions, function(option) {
                            return _c(
                              "option",
                              {
                                key: option.value,
                                domProps: { value: option.value }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(option.label) +
                                    "\n          "
                                )
                              ]
                            )
                          })
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "form-group d-flex flex-column col-lg-4 p-0 pb-3"
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$resourceString["checkout.SFDC.no-projects"]
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: { click: _vm.toggleAddProjectSection }
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$resourceString["checkout.SFDC.add-new"]
                                ) +
                                "\n        "
                            )
                          ]
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.addingNewProject
                ? _c("div", [
                    _c("div", { staticClass: "form-group col-lg-4 p-0" }, [
                      _c(
                        "label",
                        {
                          staticClass: "form-label",
                          attrs: { for: "newOpportunityName" }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$resourceString["checkout.SFDC.enter-name"]
                              ) +
                              "\n        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.name,
                            expression: "name"
                          }
                        ],
                        staticClass: "form-input",
                        attrs: {
                          id: "newOpportunityName",
                          type: "text",
                          placeholder:
                            _vm.$resourceString[
                              "checkout.SFDC.project-name-placeholder"
                            ]
                        },
                        domProps: { value: _vm.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.name = $event.target.value
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group col-lg-4 p-0" }, [
                      _c(
                        "label",
                        {
                          staticClass: "form-label",
                          attrs: { for: "opportunityType" }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$resourceString["checkout.SFDC.project-type"]
                            )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectedType,
                              expression: "selectedType"
                            }
                          ],
                          staticClass: "form-select custom-select",
                          attrs: { id: "opportunityType" },
                          on: {
                            change: [
                              function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.selectedType = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                              _vm.handleSelectedType
                            ]
                          }
                        },
                        [
                          _c("option", { attrs: { disabled: "", value: "" } }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "checkout.SFDC.select-project-type"
                                  ]
                                ) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.typeOptions, function(option) {
                            return _c(
                              "option",
                              {
                                key: option.value,
                                domProps: { value: option.value }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(option.label) +
                                    "\n          "
                                )
                              ]
                            )
                          })
                        ],
                        2
                      )
                    ]),
                    _vm._v(" "),
                    _vm.selectedType
                      ? _c("div", { staticClass: "form-group col-lg-4 p-0" }, [
                          _c(
                            "label",
                            {
                              staticClass: "form-label",
                              attrs: { for: "opportunity" }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$resourceString["checkout.SFDC.segment"]
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selectedProject,
                                  expression: "selectedProject"
                                }
                              ],
                              staticClass: "form-select custom-select",
                              attrs: { id: "opportunity" },
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.selectedProject = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  },
                                  _vm.handleProjectChange
                                ]
                              }
                            },
                            [
                              _c(
                                "option",
                                { attrs: { disabled: "", value: "" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$resourceString[
                                        "checkout.SFDC.select-segment-type"
                                      ]
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.projectOptions, function(option) {
                                return _c(
                                  "option",
                                  {
                                    key: option.value,
                                    domProps: { value: option.value }
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(option.label) +
                                        "\n          "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedProject && _vm.primaryDPropOptions.length > 0
                      ? _c("div", { staticClass: "form-group col-lg-4 p-0" }, [
                          _c(
                            "label",
                            {
                              staticClass: "form-label",
                              attrs: { for: _vm.primaryDynamicKey }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.formatDynamicLabel(_vm.primaryDynamicKey)
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.dynamicProperties[
                                      _vm.primaryDynamicKey
                                    ],
                                  expression:
                                    "dynamicProperties[primaryDynamicKey]"
                                }
                              ],
                              staticClass: "form-select custom-select",
                              attrs: { id: _vm.primaryDynamicKey },
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.dynamicProperties,
                                      _vm.primaryDynamicKey,
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                  _vm.handlePrimaryDPropChange
                                ]
                              }
                            },
                            [
                              _c(
                                "option",
                                { attrs: { disabled: "", value: "" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$resourceString[
                                        "checkout.SFDC.select-option"
                                      ]
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.primaryDPropOptions, function(option) {
                                return _c(
                                  "option",
                                  {
                                    key: option.value,
                                    domProps: { value: option.value }
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(option.label) +
                                        "\n          "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.dynamicProperties[_vm.primaryDynamicKey] &&
                    _vm.secondaryDPropOptions.length > 0
                      ? _c("div", { staticClass: "form-group col-lg-4 p-0" }, [
                          _c(
                            "label",
                            {
                              staticClass: "form-label",
                              attrs: { for: _vm.secondaryDynamicKey }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.formatDynamicLabel(
                                    _vm.secondaryDynamicKey
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.dynamicProperties[
                                      _vm.secondaryDynamicKey
                                    ],
                                  expression:
                                    "dynamicProperties[secondaryDynamicKey]"
                                }
                              ],
                              staticClass: "form-select custom-select",
                              attrs: { id: _vm.secondaryDynamicKey },
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.dynamicProperties,
                                      _vm.secondaryDynamicKey,
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                  _vm.handleSecondaryDPropChange
                                ]
                              }
                            },
                            [
                              _c(
                                "option",
                                { attrs: { disabled: "", value: "" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$resourceString[
                                        "checkout.SFDC.select-option"
                                      ]
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.secondaryDPropOptions, function(
                                option
                              ) {
                                return _c(
                                  "option",
                                  {
                                    key: option.value,
                                    domProps: { value: option.value }
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(option.label) +
                                        "\n          "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "pb-3" }, [
                      _c(
                        "a",
                        {
                          attrs: { href: "#" },
                          on: { click: _vm.toggleAddProjectSection }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$resourceString[
                                  "checkout.SFDC.existing-projects"
                                ]
                              ) +
                              "\n        "
                          )
                        ]
                      )
                    ])
                  ])
                : _vm._e()
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }